import React from 'react';
import DateRangePicker from '../common/DateRangePicker';

const PRESETS = [
  { id: 'today', label: 'Today' },
  { id: '7d', label: 'Last 7 Days' },
  { id: '30d', label: 'Last 30 Days' },
  { id: 'month', label: 'This Month' },
  { id: 'all', label: 'All Time' },
];

const DashboardFilterBar = ({
  activePreset,
  onPresetChange,
  startDate,
  endDate,
  onDateRangeChange,
  onRefresh,
  loading = false,
}) => {
  return (
    <div className='bg-white rounded-xl shadow-xs border border-gray-200 p-4 mb-6 transition-all'>
      <div className='flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4'>
        {/* Preset Chips */}
        <div className='flex flex-wrap items-center gap-2'>
          <span className='text-xs font-semibold uppercase tracking-wider text-gray-400 mr-1'>
            Timeframe:
          </span>
          {PRESETS.map(preset => {
            const isActive = activePreset === preset.id;
            return (
              <button
                key={preset.id}
                onClick={() => onPresetChange(preset.id)}
                className={`px-3 py-1.5 rounded-lg text-xs font-semibold transition-all cursor-pointer ${
                  isActive
                    ? 'bg-blue-600 text-white shadow-xs'
                    : 'bg-gray-100 text-gray-600 hover:bg-gray-200 hover:text-gray-900'
                }`}
              >
                {preset.label}
              </button>
            );
          })}
        </div>

        {/* Date Range Picker & Refresh Button */}
        <div className='flex items-center gap-3 self-end lg:self-auto'>
          <div className='w-64 sm:w-72'>
            <DateRangePicker
              startDate={startDate}
              endDate={endDate}
              onDateRangeChange={onDateRangeChange}
              label={{ start: '', end: '' }}
              placeholder='Select custom date range'
              className='-mt-2'
            />
          </div>

          <button
            onClick={onRefresh}
            disabled={loading}
            title='Refresh Dashboard Data'
            className='inline-flex items-center justify-center p-2.5 rounded-lg border border-gray-300 bg-white text-gray-700 hover:bg-gray-50 focus:outline-hidden focus:ring-2 focus:ring-blue-500 disabled:opacity-50 cursor-pointer shadow-2xs'
          >
            <svg
              className={`w-4 h-4 text-gray-600 ${loading ? 'animate-spin text-blue-600' : ''}`}
              fill='none'
              stroke='currentColor'
              viewBox='0 0 24 24'
            >
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth={2}
                d='M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15'
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default DashboardFilterBar;
